<template>
	<div class="display-flex flex-row flex-align-center width-100">
		<MappingIconSvg />
		<div class="ml-1 title-text">Create a mapping block for</div>
		<IntegrationIcon :integrationName="service.service_slug" class="mx-2" :size="25" />
		<div class="title-text">{{ service.service_name }}</div>
		<div class="title-text ml-2">{{ service.item_type }}</div>
		<div class="title-text ml-1">{{ fieldItem }}</div>
	</div>
</template>

<script>
import MappingIconSvg from '../assets/MappingIconSvg';

export default {
	name: 'DialogHeader',
	components: {
		MappingIconSvg,
	},
	props: {
		service: { type: Object },
		fieldItem: { type: String },
	},
};
</script>
<style scoped lang="scss">
.title-text {
	font-size: 12px;
	color: var(--primary-font-color);
}
</style>
